<template>
  <!--
    	作者：kmdshop
    	时间：2020-06-20
    	描述：diy组件-参数设置-搜索栏
    -->
  <div>
    <div class="common-form"><span>{{ curItem.name }}</span></div>
     <el-form size="small" :model="curItem" label-width="100px">
       <el-form-item label="图表类型：">
         <el-radio-group v-model="curItem.params.type">
             <el-radio :key="index" :label="item.id" v-for="item,index in curItem.params.type_arr">{{item.text}}</el-radio>
           </el-radio-group>
       </el-form-item>
    </el-form>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        image_id:'',
         /*是否上传图片*/
        isupload: false,
        index: null,
        urlList : [],
        /*是否选择链接*/
        is_linkset: false,
      };
    },
    props: ['curItem', 'selectedIndex', 'opts'],
    created() {
        console.log("curItem",this.curItem)
        console.log("selectedIndex",this.selectedIndex)
        console.log("opts",this.opts)
    },
    methods: {
      /*上传*/
      openUpload(e) {
        this.type = e;
        this.isupload = true;
      },
      /*获取图片*/
      returnImgsFunc(e) {
        console.log(e);
        if (e != null && e.length > 0) {
          this.file_path = e[0].file_path;
          this.image_id = e[0].file_id;
          this.curItem.params.img_url = this.file_path;
        }
        this.isupload = false;
      },


      /*选择链接*/
        changeLink(index) {
            this.is_linkset = true;
            this.index = index;
        },

    /*获取链接并关闭弹窗*/
      closeLinkset(e) {
          this.is_linkset = false;
          if (e) {
            this.curItem.params.icon_link = e.url
            // this.curItem.data[this.index].name = e.name
          }
      },
    }
  };
</script>

<style scoped>
  .img {
     margin-top: 10px;
   }
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/params/Chart.vue